import { ThumbUp } from "components/icons/generated";
import Button from "ds/components/Button";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";
import { isSelfHostedDistribution } from "utils/distribution";
import { openFeaturebaseFeedbackWidget } from "utils/featurebase";
import ActionCard from "ds/components/ActionCard";

const DashboardOverviewColumnLeaveFeedback = () => {
  const isSelfHosted = isSelfHostedDistribution();

  if (isSelfHosted) {
    return null;
  }

  return (
    <ActionCard
      title="Leave feedback"
      description="Do you have any ideas or feedback that you would like to share with us?"
      icon={ThumbUp}
      iconBackgroundColor="var(--semantic-color-background-decoration-blue-subdued)"
      actionComponent={
        <Button
          size="medium"
          variant="secondary"
          analyticsPage={AnalyticsPageDashboard.Dashboard}
          analyticsTitle="Dashboard - Overview Column Leave Feedback Clicked"
          onPress={openFeaturebaseFeedbackWidget}
        >
          Leave feedback
        </Button>
      }
    />
  );
};

export default DashboardOverviewColumnLeaveFeedback;
